interface NeoSDRLogoProps {
  className?: string;
  textColor?: string;
  iconWhite?: boolean;
}

export const NeoSDRLogo = ({ className = "", textColor = "#182f9a", iconWhite = false }: NeoSDRLogoProps) => (
  <svg
    viewBox="0 0 3967 1488"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="NeoSDR"
  >
    <path
      d="M937.5,755.135l0,71.577c0,19.752 -16.036,35.788 -35.788,35.788l-398.33,0c-19.752,0 -35.788,-16.036 -35.788,-35.788l0,-71.577c0,-19.752 16.036,-35.788 35.788,-35.788l398.33,0c19.752,0 35.788,16.036 35.788,35.788Z"
      fill={iconWhite ? "#ffffff" : "#3a73d7"}
      style={{ transition: "fill 0.3s ease" }}
    />
    <path
      d="M793.324,929.451l0,71.577c0,19.752 -16.036,35.788 -35.788,35.788l-398.33,0c-19.752,0 -35.788,-16.036 -35.788,-35.788l0,-71.577c0,-19.752 16.036,-35.788 35.788,-35.788l398.33,0c19.752,0 35.788,16.036 35.788,35.788Z"
      fill={iconWhite ? "#ffffff" : "#8bc2e5"}
      style={{ transition: "fill 0.3s ease" }}
    />
    <path
      d="M1078.316,576.515l0,71.577c0,19.752 -16.036,35.788 -35.788,35.788l-398.33,0c-19.752,0 -35.788,-16.036 -35.788,-35.788l0,-71.577c0,-19.752 16.036,-35.788 35.788,-35.788l398.33,0c19.752,0 35.788,16.036 35.788,35.788Z"
      fill={iconWhite ? "#ffffff" : "#182f9a"}
      style={{ transition: "fill 0.3s ease" }}
    />
    <text
      x="1147.927"
      y="989.728"
      style={{
        fontFamily: "'Cocogoose Pro', sans-serif",
        fontWeight: 300,
        fontSize: "533.971px",
        fill: textColor,
        transition: "fill 0.3s ease",
      }}
    >
      NeoSDR
    </text>
  </svg>
);
